import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './public/login/login.component';
import {DashboardComponent} from './public/dashboard/dashboard.component';
import {HomeComponent} from './public/home/home.component';
import {UsuariosComponent} from './public/usuarios/usuarios.component';
import {TransaccionesComponent} from './public/transacciones/transacciones.component';
import { AnalisisComponent} from './public/biodiversidad/analisis/analisis.component';
import { EstadisticasComponent} from './public/biodiversidad/estadisticas/estadisticas.component';
import { EcosistemasComponent} from './public/ecosistemas/ecosistemas.component';
import { EcosistemaAnalisisComponent} from './public/ecosistema-analisis/ecosistema-analisis.component';
import { FormulariosComponent} from './public/formularios/formularios/formularios.component';
import {EmpresasComponent} from './public/administracion/empresas/empresas.component'
import { FormulariosEncuestasComponent} from './public/formularios/formularios-encuestas/formularios-encuestas.component';
import {CrearComponent } from './public/formularios/crear/crear.component';
import { EditEmpresaComponent } from './public/administracion/empresas/edit-empresa/edit-empresa.component';
import { EditUsuariosComponent } from './public/usuarios/edit-usuarios/edit-usuarios.component';
import { EditarFormularioComponent } from './public/formularios/crear/editar-formulario/editar-formulario.component';
import { ResultadosComponent } from './public/formularios/formularios-encuestas/resultados/resultados/resultados.component';


const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'registrar',
    component: LoginComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'usuarios',
        component: UsuariosComponent
      },
      {
        path: 'editUsuarios/:id',
        component: EditUsuariosComponent
      },
      {
        path: 'analisis',
        component: AnalisisComponent
      },
      {
        path: 'estadisticas',
        component: EstadisticasComponent
      },
      {
        path: 'ecosistemas',
        component: EcosistemasComponent
      },
      {
        path: 'ecosistema-analisis',
        component: EcosistemaAnalisisComponent
      },
      {
        path: 'formularios',
        component: FormulariosComponent
      },
      {
        path: 'resultados/:id',
        component: ResultadosComponent
      },
      {
        path: 'empresas',
        component: EmpresasComponent
      },
      {
        path: 'editEmpresas/:id',
        component: EditEmpresaComponent
      },
      {
        path: 'encuestas',
        component: FormulariosEncuestasComponent
      },
      {
        path: 'crear-formularios',
        component: CrearComponent
      },
      {
        path: 'editFormulario/:id',
        component: EditarFormularioComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
